var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155,
    height: 203,
    viewBox: "0 0 155 203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 155,
    height: 203,
    transform: "translate(810.816 378.588)",
    fill: "#00caa6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-810.816 -378.588)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M875.1,428.639l-3.385.726h-.086a1.288,1.288,0,0,1-1.564-1,1.316,1.316,0,0,1,1.007-1.56l3.557-.77a1.325,1.325,0,1,1,.578,2.586h-.085Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M866.718,430.818c-2.207.727-4.349,1.582-6.492,2.5a1.278,1.278,0,1,1-1.05-2.33c2.186-.983,4.414-1.859,6.685-2.65a1.3,1.3,0,1,1,.836,2.458Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M855.535,435.584q-3.084,1.6-6.042,3.462a1.248,1.248,0,0,1-1.714-.385,1.215,1.215,0,0,1,.386-1.688c2.014-1.282,4.092-2.5,6.192-3.612a1.263,1.263,0,1,1,1.2,2.223Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M845.142,441.952c-1.885,1.368-3.707,2.8-5.464,4.317a1.194,1.194,0,0,1-1.692-.128,1.18,1.18,0,0,1,.107-1.667c1.8-1.581,3.664-3.077,5.614-4.488a1.224,1.224,0,1,1,1.457,1.966Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M835.865,449.838a61.888,61.888,0,0,0-4.607,5.172,1.179,1.179,0,0,1-1.629.192,1.148,1.148,0,0,1-.192-1.6,60.02,60.02,0,0,1,4.756-5.406,1.181,1.181,0,0,1,1.672,1.667Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M828.237,459.22a44.592,44.592,0,0,0-3.257,6.048,1.108,1.108,0,0,1-2.035-.876A44.471,44.471,0,0,1,826.33,458a1.135,1.135,0,0,1,1.929,1.2Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M823.287,470.119a29.794,29.794,0,0,0-1.05,6.732,1.061,1.061,0,0,1-1.114,1.026,1.075,1.075,0,0,1-1.029-1.112,32.667,32.667,0,0,1,1.072-7.2,1.086,1.086,0,0,1,2.1.556Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M822.495,481.916a29.06,29.06,0,0,0,1.757,6.56,1,1,0,0,1-.579,1.325,1.01,1.01,0,0,1-1.328-.577,30.47,30.47,0,0,1-1.929-7.031,1.052,1.052,0,0,1,2.079-.32Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M826.522,493.092a39.323,39.323,0,0,0,4.006,5.6.983.983,0,0,1-.128,1.389,1.009,1.009,0,0,1-1.393-.107,43.8,43.8,0,0,1-4.242-5.856,1.03,1.03,0,0,1,.343-1.389,1.017,1.017,0,0,1,1.392.342Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M834.087,502.5a45.569,45.569,0,0,0,5.335,4.4.929.929,0,0,1,.214,1.3.956.956,0,0,1-1.307.235,49.3,49.3,0,0,1-5.592-4.531.968.968,0,1,1,1.328-1.41Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M843.835,509.676a46.935,46.935,0,0,0,6.3,2.928.867.867,0,0,1,.514,1.154.887.887,0,0,1-1.157.513,50.29,50.29,0,0,1-6.556-2.992.928.928,0,1,1,.9-1.624Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M855.084,514.164a46.261,46.261,0,0,0,6.836,1.218.858.858,0,0,1-.15,1.71,44.425,44.425,0,0,1-7.093-1.218.882.882,0,1,1,.429-1.71Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M867.1,515.6a41.071,41.071,0,0,0,6.878-.684.822.822,0,0,1,.964.641.8.8,0,0,1-.642.94,42.883,42.883,0,0,1-7.178.77.834.834,0,1,1-.043-1.667Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M878.955,513.48a18.157,18.157,0,0,0,5.742-3.526.76.76,0,0,1,1.093.043.773.773,0,0,1-.022,1.09,19.637,19.637,0,0,1-6.213,3.889.774.774,0,0,1-1.029-.427.787.787,0,0,1,.429-1.026Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M887.7,505.936a16.631,16.631,0,0,0,1.629-6.518.73.73,0,0,1,1.457.086,18.294,18.294,0,0,1-1.736,7.1.752.752,0,0,1-1.35-.663Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M888.939,494.375a13.468,13.468,0,0,0-3.149-5.856.682.682,0,0,1,1.007-.919,14.826,14.826,0,0,1,3.514,6.433.684.684,0,0,1-.515.855.7.7,0,0,1-.857-.513Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M881.824,485.314a25.564,25.564,0,0,0-6.342-2.672.643.643,0,1,1,.343-1.239,27.554,27.554,0,0,1,6.685,2.757.671.671,0,1,1-.686,1.154Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M870.382,481.638a44.619,44.619,0,0,0-6.964-.321.6.6,0,1,1-.043-1.2,47.2,47.2,0,0,1,7.157.278.614.614,0,1,1-.15,1.218Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M858.192,481.723a54.122,54.122,0,0,0-6.878,1.347.565.565,0,0,1-.3-1.09,55.7,55.7,0,0,1,7.006-1.411.583.583,0,1,1,.172,1.154Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M846.3,484.63a53.308,53.308,0,0,0-6.427,2.778.508.508,0,0,1-.686-.235.515.515,0,0,1,.214-.684,57.075,57.075,0,0,1,6.535-2.864.534.534,0,1,1,.364,1.005Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M835.308,489.994a50.885,50.885,0,0,0-5.656,4.124.471.471,0,1,1-.6-.726,52.963,52.963,0,0,1,5.742-4.232.5.5,0,1,1,.536.834Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M825.773,497.666a49.09,49.09,0,0,0-4.521,5.342.419.419,0,0,1-.6.086.415.415,0,0,1-.085-.6,50.447,50.447,0,0,1,4.564-5.471.454.454,0,0,1,.642.641Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M818.381,507.411a51.944,51.944,0,0,0-3.064,6.3.38.38,0,0,1-.707-.278,47.5,47.5,0,0,1,3.064-6.411.408.408,0,0,1,.707.406Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M813.625,518.7a56.735,56.735,0,0,0-1.5,6.86.323.323,0,0,1-.386.277.313.313,0,0,1-.279-.384,58.916,58.916,0,0,1,1.457-6.946.366.366,0,0,1,.707.193Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M811.567,530.769a47.953,47.953,0,0,0,0,7.01.3.3,0,0,1-.6.042,52.518,52.518,0,0,1-.043-7.095.333.333,0,0,1,.665.022Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M812.36,542.972a35.033,35.033,0,0,0,2.249,6.625.258.258,0,0,1-.471.213,34.145,34.145,0,0,1-2.336-6.71.286.286,0,0,1,.558-.128Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M817.16,554.191a40.015,40.015,0,0,0,4.371,5.492.212.212,0,0,1-.3.3,38.261,38.261,0,0,1-4.457-5.535.232.232,0,0,1,.386-.257Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M825.367,563.295a56.937,56.937,0,0,0,5.678,4.167.169.169,0,1,1-.192.278,57.476,57.476,0,0,1-5.743-4.146.2.2,0,0,1,.257-.3Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M835.609,570.155c2.078,1.111,4.2,2.137,6.363,3.056a.115.115,0,1,1-.085.214c-2.186-.919-4.307-1.923-6.407-3.035a.143.143,0,1,1,.129-.256Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M846.878,575.177c2.207.812,4.457,1.539,6.707,2.2a.068.068,0,0,1-.043.129c-2.271-.642-4.521-1.368-6.749-2.159-.043,0-.086-.085-.065-.128s.086-.086.129-.064Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M858.726,578.767l6.921,1.518s.022,0,.022.043c0,0,0,.021-.043.021l-6.921-1.453s-.043-.043-.043-.064.043-.043.064-.043Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M870.877,581.161l3.535.427-3.535-.406Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M906.7,389.936c.278-.3-22.091,4.4-22.091,4.4l-6.385,32.4,17.269-19.725,25.22,4.018,45.06-19.4-59.095-1.688Z",
    fill: "#1ed0b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M965.817,391.625l-87.571,35.112,17.291-19.726Z",
    fill: "#00caa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M965.816,391.624l-94.277-13.036,13.092,15.751,81.185-2.715-70.279,15.387L917.5,434.622Z",
    fill: "#18e9c4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.268516eacae7846445983c892fb02489.svg";
export { ForwardRef as ReactComponent };